import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class GoalsInsightsRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel() {
		this.navigationService.transitionToRoute('goals.insights.detail');
	}
}
